import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-carbon font-sans text-muted antialiased" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mj6j3vjtnyfg" />
      <main data-id="element-2" data-mp="3rcj8i7wbs999">
        <Hero data-id="element-3" data-mp="3rbzmog3k10py" />
        <SocialProof data-id="element-4" data-mp="3rdatkosaqola" />
        <Testimonials data-id="element-5" data-mp="3rd1all5o5hp3" />
        <ProblemSection data-id="element-6" data-mp="3relvsk63foaa" />
        <SystemSection data-id="element-7" data-mp="6hp9c27i9cj" />
        <ModulesSection data-id="element-8" data-mp="4n4bxqxqh8g" />
        <BonusSection data-id="element-9" data-mp="56lhc8rh1lf" />
        <UrgencySection data-id="element-10" data-mp="2zl3alhpbj03q" />
        <PricingSection data-id="element-11" data-mp="2zllijblcf2rh" />
        <MoreResults data-id="element-12" data-mp="2zmenc70qri6z" />
        <GuaranteeSection data-id="element-13" data-mp="2zn69yscd25l4" />
        <FAQ data-id="element-14" data-mp="33moqzd129wio" />
        <ClosingSection data-id="element-15" data-mp="33m5ck6amdq9e" />
        <SummaryTable data-id="element-16" data-mp="33ngdzzglelxc" />
        <FinalCta data-id="element-17" data-mp="33mylndx1wrup" />
      </main>
      <Footer data-id="element-18" data-mp="38m1g64fenfof" />
      <PurchaseNotification data-id="element-19" data-mp="38l8hlqqlnwhd" />
    </div>;
}